import HttpError from 'utils/HttpError';
import trackError from 'utils/trackError';

type SetErrorAction = {
  type: 'SET_ERROR';
  error: Error;
};
export type Action = SetErrorAction;
export const setError = (error: Error, track = true): SetErrorAction => {
  if (track && error instanceof HttpError && error.statusCode !== 404) {
    trackError(error);
  }

  return {
    type: 'SET_ERROR',
    error,
  };
};
